<template>
    <v-container fluid class="pa-0">
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title> Background Tasks </v-card-title>
                </v-card>
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="backgroundTasks"
                        class="mt-2 pt-2"
                        :items-per-page="100"
                        :footer-props="{ itemsPerPageOptions: [25, 50, 100, -1] }"
                    >
                        <template v-slot:item.more_info="{ item }">
                            {{
                                item.more_info
                                    ? item.more_info.message || item.more_info.error
                                    : "N/A"
                            }}
                        </template>
                        <template v-slot:item.status="{ item }">
                            <v-chip
                                :color="
                                    item.status === 'completed'
                                        ? 'green'
                                        : item.status === 'failed'
                                          ? 'red'
                                          : 'blue'
                                "
                            >
                                {{ item.status }}
                            </v-chip>
                        </template>
                        <template v-slot:item.queued_at="{ item }">
                            {{ formatTimestamp(item.queued_at) }}
                        </template>
                        <template v-slot:item.started_at="{ item }">
                            {{ formatTimestamp(item.started_at) }}
                        </template>
                        <template v-slot:item.finished_at="{ item }">
                            {{ formatTimestamp(item.finished_at) }}
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { defineComponent } from "vue";

import { withLoadingScreen } from "@/lib/loading";
import { backgroundTasksAPI } from "@/services/api.services";
import { getDateTimeForTimestampDisplay } from "@/lib/dateUtils";

export default defineComponent({
    name: "BackgroundTaskList",

    async mounted() {
        withLoadingScreen(async () => {
            await this.reloadBackgroundTasks();
        });
    },

    methods: {
        async reloadBackgroundTasks() {
            this.backgroundTasks = await backgroundTasksAPI.fetchBackgroundTasks();
        },
    },

    computed: {
        formatTimestamp() {
            return (timestamp) => {
                if (!timestamp) {
                    return "";
                } else {
                    return getDateTimeForTimestampDisplay(new Date(timestamp));
                }
            };
        },
    },

    data() {
        return {
            headers: [
                { title: "ID", value: "id" },
                { title: "Task Type", value: "task_type" },
                { title: "Status", value: "status" },
                { title: "More Info", value: "more_info" },
                { title: "Queued At", value: "queued_at" },
                { title: "Started At", value: "started_at" },
                { title: "Finished At", value: "finished_at" },
            ],
            backgroundTasks: [],
        };
    },
});
</script>

<style></style>
